import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../../navigation/route/Route";
import * as classNames from "classnames";
import AssigneeChangeNotification from "../../../../../model/notification/assignee/AssigneeChangeNotification";

interface IComponentProps {
	/**
	 * Notification for display.
	 */
	notification: AssigneeChangeNotification;
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string) => void;
}

type Props = IComponentProps & RouteComponentProps<IComponentProps>;

class NotificationLeadAssigneeItem extends React.PureComponent<Props> {
	constructor(props: Props) {
		super(props);
		this.routeToLead = this.routeToLead.bind(this);
	}

	render() {

		const classFromProps = classNames({
			"c-notification": true,
			"active": !this.props.notification.read
		});

		return (
			<div className={classFromProps}>
				<div className={"notification-icon"}>
					<img src="/assets/img/icons/icon-noti-reminder.svg"/>
				</div>
				<div className={"notification-body"}>
					<div className={"notification-header"}>
						Lead {this.props.notification.data.getLeadReferenceNumber()} &middot;
						Assignee(s) changed
						from {this.props.notification.displayPreviousAssignees()} to {this.props.notification.displayCurrentAssignees()}
					</div>
					<div className={"notification-content"}>
						{this.props.notification.displayCreatorName()}<br/>
						{this.props.notification.displayDate()}
					</div>
					<span className="notification-link" onClick={this.routeToLead}>View</span>
					<span className="notification-link-separator">|</span>
					{this.renderNotificationActions()}
				</div>
			</div>
		);
	}

	/**
	 * Render notification actions.
	 */
	renderNotificationActions() {
		if (this.props.notification.read) {
			return <span className="notification-link"
						 onClick={() => this.props.markUnreadNotification(this.props.notification.id)}>Mark as Unread</span>;
		}
		return <span className="notification-link" onClick={() => this.props.markReadNotification(this.props.notification.id)}>Mark as Read</span>;
	}

	/**
	 * Route to Proper lead and pass Comment Id.
	 */
	routeToLead() {
		this.props.history.push(Routes.EditLead(this.props.notification.data.getLeadReferenceNumber()));
	}
}

export default withRouter<IComponentProps>(NotificationLeadAssigneeItem);